import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { usePayment } from '@/stores/payment-store';

export function DevToolsPage() {
  const { deselectPayment } = usePayment();

  return (
    <div className="flex flex-col gap-2 p-8 transition-transform active:scale-95">
      <Button
        onClick={() => {
          deselectPayment();
          toast.success('Deselected payment', { position: 'bottom-center' });
        }}
      >
        Deselect payment
      </Button>
    </div>
  );
}
